import { useMutation } from '@tanstack/react-query'
import type { ReturnsApiExchangeOptionsRequest } from '@itsrever/rever-api'
import { returnsApi } from '@/services/api/returns-api'

const getExchangeOptions = async ({
  ecommerceId,
  returnsExchangeOptionsRequest
}: ReturnsApiExchangeOptionsRequest) => {
  const { data } = await returnsApi.exchangeOptions({
    ecommerceId,
    returnsExchangeOptionsRequest
  })

  return data
}

export const useExchangeOptions = () => {
  return useMutation({
    mutationFn: getExchangeOptions
  })
}
